export enum Grid {
  MIL100 = 100,
  MIL75 = 75,
}

export enum TipStyle {
  SMALL_SINGLE_POINT = "SmallSinglePoint",
  WIDE_SINGLE_POINT = "WideSinglePoint",
  CONCAVE = "Concave",
}

export interface Sleeve {
  supplier: string;
  order_number: string;
  diameter: number;
  diameter_spacing: number;
  sk_number: string;
}

export interface Needle {
  tip_style: TipStyle;
  supplier: string;
  order_number: string;
  diameter: number;
  current: number;
  diameter_spacing: number;
  sk_number: string;
  image_name: string;
}

export interface Contact {
  id: string;
  description: string;
  needle: Needle;
  sleeve: Sleeve;
  grid: Grid;
}